import { T } from '@tribeplatform/react-components/i18n'

import { PublishSettings } from '../PublishSettings.js'

export function CommunityPublishSettingsRouter() {
  return <PublishSettings />
}

export function CommunityPublishSettingsBreadCrumb() {
  return <T id="Settings.Publish" defaultMessage="Publish" />
}
